/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DdtNumeration } from '../../models/ddt-numeration';

export interface DdtControllerGenerateNumber$Params {
  related_agreement_id?: number;
  related_delivery_id?: number;
  year?: number;

/**
 * Se specificato, ignora la logica di numerazione basata sulla commessa e usa sempre l'internal_code di questa registry come prefisso (es. DDT generati automaticamente da un trasferimento di magazzino)
 */
  force_registry_id?: number;
}

export function ddtControllerGenerateNumber(http: HttpClient, rootUrl: string, params?: DdtControllerGenerateNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtNumeration;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerGenerateNumber.PATH, 'get');
  if (params) {
    rb.query('related_agreement_id', params.related_agreement_id, {});
    rb.query('related_delivery_id', params.related_delivery_id, {});
    rb.query('year', params.year, {});
    rb.query('force_registry_id', params.force_registry_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DdtNumeration;
      }>;
    })
  );
}

ddtControllerGenerateNumber.PATH = '/ddt/generate-number';
